
/**
 * Custom component for Oceano All-you-can-eat menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2023, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-10-05 (1.0.0) (jhoward)
 *      - <OceanoAyceSection> adds an All-You-Can-Eat layout for Oceano menu sections.
 */

import {defineComponent, PropType} from "vue";
import OceanoDefaultSection from "./OceanoDefaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'OceanoAyceSection',
  components: {OceanoDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
